import { Card } from "react-bootstrap";
import { FaTasks } from "react-icons/fa";
import { GoGoal } from "react-icons/go";
import { LuCalendarHeart } from "react-icons/lu";
import { FaLocationDot } from "react-icons/fa6";
import { GrAnnounce } from "react-icons/gr";
import { ControlTranslation } from "AlignComponents";
import { useAppSelector } from "@/Hook/hooks";

const Announcements = () => {
  const announcements = useAppSelector(x => x.Home.announcements);

  return (
    <div className="widget announcements">
      <Card>
        <Card.Header>
          <Card.Title>
            <GrAnnounce size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblannouncements" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="announcements">
            {
              announcements.map(x => (
                <div className="announcement">
                  <img src={`data:image/jpeg;base64,${x.announcementimage}`} alt="" />
                  <div className="text">
                    <h6>
                      {x.announcementstxt}
                    </h6>
                    <span>
                      {x.announcementltxt}
                    </span>
                  </div>
                </div>
              ))
            }
          </div>
          {/* <div className="announcements">
           

            <div className="announcement">
              <img src={require("@/Assets/Images/announcement-2.jpg").default} alt="" />
              <div className="text">
                <h6>
                  Employee Wellness Program Launch!
                </h6>
                <span>
                  We’re thrilled to launch our new Employee Wellness Program! Join us for weekly yoga classes, wellness challenges, and health screenings starting January 2025. Let’s prioritize our well-being together.
                </span>
              </div>
            </div>
          </div> */}
        </Card.Body>
      </Card>
    </div >
  )
};

export default Announcements;